import httpbaseURL from "../common/axios";
debugger;
class Commonservices {
  Create(doc) {
    debugger;
    return httpbaseURL.httpMSUserManageMentUrl.post(
      "/EntityOperations/Create",
      doc
    );
  }
  List() {
    debugger;
    return httpbaseURL.httpMSUserManageMentUrl.get("/EntityOperations/List");
  }
  Edit(Id) {
    debugger;
    return httpbaseURL.httpMSUserManageMentUrl.get(
      "/EntityOperations/Get?id=" + Id
    );
  }
  Update(doc) {
    debugger;
    return httpbaseURL.httpMSUserManageMentUrl.post(
      "/EntityOperations/Update",
      doc
    );
  }
  Delete(Id) {
    debugger;
    return httpbaseURL.httpMSUserManageMentUrl.delete(
      "/EntityOperations/Delete?ID=" + Id
    );
  }
  ListByEntityId(EntityId) {
    debugger;
    return httpbaseURL.httpMSUserManageMentUrl.get(
      "/EntityOperations/ListByEntityId?EntityId=" + EntityId + ""
    );
  }
}
export default new Commonservices();
